// tslint:disable
/**
 * TC API
 * TestCollab is a test management tool that helps development teams carry out testing effectively and avoid failures. # Introduction This is an API documentation for TestCollab 2.   # Authentication TestCollab supports two forms of authentication:   - An <b>API token</b> is required to make API calls. The token can be generated from user's profile; to obtain it login to your TestCollab account and go to ['My Profile Settings'](https://testcollab.io/my_profile) and switch to API Token tab. Click on \"Generate new API token\", Once the token is generated it can be sent as a query parameter for the API calls made - https://api.testcollab.io/projects?token=<generated-API-token>    - <b>Bearer authentication</b> (also called token authentication) is an HTTP authentication scheme that involves security tokens called bearer tokens. You can generate bearer auth token using [Login](#operation/login) API.     Send this token as the Authorization header while making requests to protected resources:     `Authorization: Bearer <token>`    For making API calls, we recommend using the <b>API token</b> generated from user profile page as it won't affect the on-going user session and will be available until it is revoked by the user who generated it.      # Error Handling Error responses   - `Not Found` - Error is sent when requested resource is not available.   - `Unauthorized - invalid token` - Error is sent when API token sent with the request is invalid or revoked. Error contains status code 401        - `Forbidden` - Error is sent when logged in user is not part of the company, project or his role does not allow to complete given action. Response consist of 403 status code and more information is given in error message.
 *
 * OpenAPI spec version: 2.3.1
 * Contact: support@testcollab.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import * as runtime from "../runtime";
import {
  GenericActionResult,
  GenericActionResultFromJSON,
  GenericActionResultToJSON,
  Projectsetting,
  ProjectsettingFromJSON,
  ProjectsettingToJSON,
  ProjectsettingPayload,
  ProjectsettingPayloadFromJSON,
  ProjectsettingPayloadToJSON,
  TCError,
  TCErrorFromJSON,
  TCErrorToJSON,
} from "../models";

export interface DeleteProjectSettingRequest {
  project: number;
  filter?: string;
}

export interface GetProjectSettingsRequest {
  project: number;
  settingType?: string;
  limit?: number;
  filter?: string;
}

export interface SetProjectSettingsRequest {
  projectsettingPayload?: ProjectsettingPayload;
}

/**
 * no description
 */
export class ProjectsettingsApi extends runtime.BaseAPI {
  /**
   * Deletes settings for given project
   * Deletes settings for given project
   */
  async deleteProjectSettingRaw(
    requestParameters: DeleteProjectSettingRequest
  ): Promise<runtime.ApiResponse<any>> {
    if (
      requestParameters.project === null ||
      requestParameters.project === undefined
    ) {
      throw new runtime.RequiredError(
        "project",
        "Required parameter requestParameters.project was null or undefined when calling deleteProjectSetting."
      );
    }

    const queryParameters: runtime.HTTPQuery = {};

    if (requestParameters.project !== undefined) {
      queryParameters["project"] = requestParameters.project;
    }

    if (requestParameters.filter !== undefined) {
      queryParameters["_filter"] = requestParameters.filter;
    }

    const headerParameters: runtime.HTTPHeaders = {};

    if (this.configuration && this.configuration.apiKey) {
      headerParameters["Authorization"] =
        this.configuration.apiKey("Authorization"); // bearerAuth authentication
    }

    const response = await this.request({
      path: `/projectsettings`,
      method: "DELETE",
      headers: headerParameters,
      query: queryParameters,
    });

    return new runtime.TextApiResponse(response);
  }

  /**
   * Deletes settings for given project
   * Deletes settings for given project
   */
  async deleteProjectSetting(
    requestParameters: DeleteProjectSettingRequest
  ): Promise<any> {
    const response = await this.deleteProjectSettingRaw(requestParameters);
    return await response.value();
  }

  /**
   * Get details of project specific settings
   * Project specific settings
   */
  async getProjectSettingsRaw(
    requestParameters: GetProjectSettingsRequest
  ): Promise<runtime.ApiResponse<Array<Projectsetting>>> {
    if (
      requestParameters.project === null ||
      requestParameters.project === undefined
    ) {
      throw new runtime.RequiredError(
        "project",
        "Required parameter requestParameters.project was null or undefined when calling getProjectSettings."
      );
    }

    const queryParameters: runtime.HTTPQuery = {};

    if (requestParameters.project !== undefined) {
      queryParameters["project"] = requestParameters.project;
    }

    if (requestParameters.settingType !== undefined) {
      queryParameters["setting_type"] = requestParameters.settingType;
    }

    if (requestParameters.limit !== undefined) {
      queryParameters["_limit"] = requestParameters.limit;
    }

    if (requestParameters.filter !== undefined) {
      queryParameters["_filter"] = requestParameters.filter;
    }

    const headerParameters: runtime.HTTPHeaders = {};

    if (this.configuration && this.configuration.apiKey) {
      headerParameters["Authorization"] =
        this.configuration.apiKey("Authorization"); // bearerAuth authentication
    }

    const response = await this.request({
      path: `/projectsettings`,
      method: "GET",
      headers: headerParameters,
      query: queryParameters,
    });

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      jsonValue.map(ProjectsettingFromJSON)
    );
  }

  /**
   * Get details of project specific settings
   * Project specific settings
   */
  async getProjectSettings(
    requestParameters: GetProjectSettingsRequest
  ): Promise<Array<Projectsetting>> {
    const response = await this.getProjectSettingsRaw(requestParameters);
    return await response.value();
  }

  /**
   * settings to save
   * Save settings
   */
  async setProjectSettingsRaw(
    requestParameters: SetProjectSettingsRequest
  ): Promise<runtime.ApiResponse<GenericActionResult>> {
    const queryParameters: runtime.HTTPQuery = {};

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters["Content-Type"] = "application/json";

    if (this.configuration && this.configuration.apiKey) {
      headerParameters["Authorization"] =
        this.configuration.apiKey("Authorization"); // bearerAuth authentication
    }

    const response = await this.request({
      path: `/projectsettings`,
      method: "POST",
      headers: headerParameters,
      query: queryParameters,
      body: ProjectsettingPayloadToJSON(
        requestParameters.projectsettingPayload
      ),
    });

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      GenericActionResultFromJSON(jsonValue)
    );
  }

  /**
   * settings to save
   * Save settings
   */
  async setProjectSettings(
    requestParameters: SetProjectSettingsRequest
  ): Promise<GenericActionResult> {
    const response = await this.setProjectSettingsRaw(requestParameters);
    return await response.value();
  }
}
